import { render } from "./ProductListComponent.vue?vue&type=template&id=24a5e100&scoped=true"
import script from "./ProductListComponent.vue?vue&type=script&lang=js"
export * from "./ProductListComponent.vue?vue&type=script&lang=js"

import "./ProductListComponent.vue?vue&type=style&index=0&id=24a5e100&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a5e100"],['__file',"resources/js/components/admin/products/ProductListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24a5e100"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24a5e100', __exports__)) {
    api.reload('24a5e100', __exports__)
  }
  
  module.hot.accept("./ProductListComponent.vue?vue&type=template&id=24a5e100&scoped=true", () => {
    api.rerender('24a5e100', render)
  })

}


export default __exports__